import { IEvaluationService } from "../../service/evaluation/EvaluationService";

export default class ExecuteReportEvaluationInteractor {
  private evaluationService: IEvaluationService;

  constructor(evaluationService) {
    this.evaluationService = evaluationService;
  }

  async execute(reportId: number) {
    return this.evaluationService.executeReportEvaluation(reportId);
  }
}
